import { render, staticRenderFns } from "./GradeForm.vue?vue&type=template&id=1543f218&"
import script from "./GradeForm.vue?vue&type=script&lang=js&"
export * from "./GradeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports